import { render, staticRenderFns } from "./GestionConfiguracionInformacionApp.vue?vue&type=template&id=7ca4cebf&"
import script from "./GestionConfiguracionInformacionApp.vue?vue&type=script&lang=js&"
export * from "./GestionConfiguracionInformacionApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports